import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const circular = typographyStyles.fontFamily.circular;
const { heading5Obj } = typographyStyles;

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { md, xs } = breakpoints.BreakpointNames;

export const rootCss = {
  width: "100%",
  marginTop: "-1px",
  display: "flex",
  backgroundColor: ui.core[700],
  padding: "16px 16px",
  color: ui.white[500],
  alignItems: "center",
  justifyContent: "space-between",
  top: "0",
  zIndex: "10",

  [mediaQuery.downTo(md)]: {
    padding: "16px 28px 16px 40px",
  },
};

const childElementBaseCss = {
  display: "flex",
  flex: "1",
  alignItems: "center",
};

export const bodyCss = {
  ...childElementBaseCss,
  ...circular,
  ...heading5Obj,
  fontWeight: "700",
  justifyContent: "center",
  letterSpacing: "1px",
  lineHeight: "auto",
  "> *": {
    margin: 0,
  },
};

export const linkCss = {
  display: "block",
};

export const logoCss = {
  ...childElementBaseCss,
  display: "flex",
  alignSelf: "center",
  marginRight: "auto",
  [mediaQuery.upTo(xs)]: {
    alignSelf: "center",
  },
};

export const closeButtonCss = {
  width: "150px",
  height: "24px",
  display: "flex",
  justifyContent: "flex-end",
  [mediaQuery.upTo(md)]: {
    width: "auto",
  },
  [mediaQuery.upTo(xs)]: {
    padding: "0 0 0 16px",
  },
};

export const actionButtonCss = {
  ...childElementBaseCss,
  marginLeft: "auto",
  justifyContent: "flex-end",
  [mediaQuery.upTo(xs)]: {
    alignSelf: "center",
  },
};

export const closeIconCSS = {
  cursor: "pointer",
  borderRadius: "4px",
  stroke: "currentColor",
  height: "100%",
  path: {
    stroke: "currentColor",
    strokeWidth: "3px",
  },
};
